import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {FormsModule} from "@angular/forms";

import {LocaleService} from "../../../../locale/locale.service";
import {ClaimsService} from "../../../../services/claims.service";
import {TextInputComponent} from "../../../common/text-input/text-input.component";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';

const licensePlateRegex = /^\d{3}[a-zA-Z]{3}$/;

@Component({
  selector: 'app-enter-license-plate',
  imports: [
    FooterComponent,
    HeaderComponent,
    FormsModule,
    TextInputComponent
],
  templateUrl: './enter-license-plate.component.html',
  styleUrl: './enter-license-plate.component.css'
})
export class EnterLicensePlateComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);


  licensePlate: string | null = null;
  showError: boolean = false;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport().licensePlate)
        this.licensePlate = this.claimService.claimReport().licensePlate;
    })
  }

  private evaluateShowError() {
    if (this.licensePlate === null) {
      this.showError = true;
    } else {
      this.showError = !licensePlateRegex.test(this.licensePlate);
    }
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({licensePlate: this.licensePlate});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['enter-license-plate'], [this.licensePlate]);
      });
    }
  }
}
